/**
 * Transport envelope. Spec §7: every response is `{ data, meta, errors }`.
 */

/*
 * `ApiError` is generated from the C# contract rather than declared here.
 *
 * It used to be a hand-written interface, and it was correct — which is the problem: it stayed
 * correct by coincidence. Both servers answer with this envelope during the transition, so it is
 * exactly the type that must not be described twice. `field` is optional and unset by the .NET
 * auth module; it carries the dotted path on validation failures, which is what turns a message
 * into an error under the right input rather than a toast.
 */
export type { ApiErrorDto as ApiError } from './contracts/index.js';
import type { ApiErrorDto } from './contracts/index.js';

export interface PaginationMeta {
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
}

export interface ApiResponse<T> {
  data: T;
  meta?: PaginationMeta & Record<string, unknown>;
  errors?: ApiErrorDto[];
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: PaginationMeta;
}

export const DEFAULT_PAGE_SIZE = 25;
/*
 * Up to 500 rows on one page.
 *
 * The office works the ειδοποιητήρια sheet the way it works a printout — scroll the whole
 * month at once rather than page through it in twenties — so the ladder reaches a size that
 * holds a full window of renewals. 500 is the ceiling rather than "all" because the cap is
 * what keeps a 20k-row book from being asked for in one request by a mistyped URL.
 */
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 250, 500] as const;
export const MAX_PAGE_SIZE = 500;

export type SortOrder = 'asc' | 'desc';

export interface ListQuery {
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortOrder?: SortOrder;
  search?: string;
}
